import { baseBackend } from "../../../../../../api/base/baseUrl";
import { URL_CANCELLATION_REASONS } from "./endpoints";

export const getListCancellationReasons = async () => {
  return await baseBackend.get(URL_CANCELLATION_REASONS, {
    headers: {
      "Content-Type": "application/json",
    },
  });
};
